import Grade from './Grade'

export default Grade